<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="activePrompt = true"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
    <vs-prompt
      v-if="activePrompt"
      class="email-compose"
      title="Update product"
      accept-text="Update"
      @cancel="activePrompt = false"
      @close="activePrompt = false"
      @accept="updateRecord"
      :active.sync="activePrompt"
    >
      <VuePerfectScrollbar
        class="scroll-area p-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <form @submit.prevent>
          <vs-input
            class="w-full mt-4"
            label="First Name"
            v-model="params.data.first_name"
            name="first_name"
          />
          <vs-input
            class="w-full mt-4"
            label="Last Name"
            v-model="params.data.last_name"
            name="last_name"
          />
          <vs-input
            class="w-full mt-4"
            label="Phone number"
            v-model="params.data.phone_number"
            v-validate="{ regex: '^\\+?([0-9]+)$' }"
            name="phone number"
          />
          <vs-input
            class="w-full mt-4"
            label="CIN"
            v-model="params.data.cin"
            name="cin"
          />
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "CellRendererClientActions",
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
    };
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete "${this.params.data.full_name}"`,
        text: `ATTENTION: la supression de "${this.params.data.full_name}" supprimera tous les articles que ce client possède.`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    async deleteRecord() {
      await this.$store.dispatch("DELETE_CLIENT", {
        _id: this.params.data._id,
      });
      this.showDeleteSuccess();
    },
    async updateRecord() {
      if (this.params.data.cin === null || this.params.data.cin === "") {
        this.params.data.cin = "-";
      }
      const payload = {
        first_name: this.params.data.first_name,
        last_name: this.params.data.last_name,
        phone_number: this.params.data.phone_number,
        cin: this.params.data.cin,
        full_name: `${this.params.data.first_name} ${this.params.data.last_name}`,
        display: `${this.params.data.ref} - ${this.params.data.first_name} ${this.params.data.last_name}`,
      };
      await this.$store.dispatch("UPDATE_CLIENT", {
        _id: this.params.data._id,
        payload,
      });
      this.activePrompt = false;
      this.showUpdateSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Client Deleted",
        text: "The selected client was successfully deleted",
      });
    },
    showUpdateSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Client Updated",
        text: "The selected client was successfully updated",
      });
    },
  },
};
</script>
